/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Job } from './Job';
import {
    JobFromJSON,
    JobFromJSONTyped,
    JobToJSON,
    JobToJSONTyped,
} from './Job';

/**
 * 
 * @export
 * @interface Email
 */
export interface Email {
    /**
     * 
     * @type {number}
     * @memberof Email
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    resume?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    coverLetter?: string;
    /**
     * 
     * @type {number}
     * @memberof Email
     */
    jobId?: number;
    /**
     * 
     * @type {Job}
     * @memberof Email
     */
    Job?: Job;
}

/**
 * Check if a given object implements the Email interface.
 */
export function instanceOfEmail(value: object): value is Email {
    return true;
}

export function EmailFromJSON(json: any): Email {
    return EmailFromJSONTyped(json, false);
}

export function EmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): Email {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'resume': json['resume'] == null ? undefined : json['resume'],
        'coverLetter': json['coverLetter'] == null ? undefined : json['coverLetter'],
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'Job': json['Job'] == null ? undefined : JobFromJSON(json['Job']),
    };
}

  export function EmailToJSON(json: any): Email {
      return EmailToJSONTyped(json, false);
  }

  export function EmailToJSONTyped(value?: Email | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'phone': value['phone'],
        'resume': value['resume'],
        'coverLetter': value['coverLetter'],
        'jobId': value['jobId'],
        'Job': JobToJSON(value['Job']),
    };
}

